import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-468e299b")

_pushScopeId("data-v-468e299b")
const _hoisted_1 = {
  class: "wf-logo-link",
  href: ""
}
const _hoisted_2 = {
  key: 1,
  class: "flex px-3"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _component_SplitButton = _resolveComponent("SplitButton")
  const _component_Toolbar = _resolveComponent("Toolbar")

  return _withDirectives((_openBlock(), _createBlock(_component_Toolbar, {
    class: ["pt-1 pb-0 wf-header shadow-6 wf-bg-blue-50", { 'pb-2': !_ctx.isMobile }]
  }, {
    start: _withId(() => [
      (_ctx.isMobile)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_Button, {
              icon: "pi pi-bars",
              class: "p-button-outlined mr-2",
              onClick: _ctx.toggleMenu
            }, null, 8, ["onClick"]),
            _createVNode(_component_Menu, {
              model: _ctx.menuItems,
              popup: true,
              ref: "headerMenuRef"
            }, null, 8, ["model"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode("a", _hoisted_1, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "wf-logo",
              src: require('@/assets/well-full.svg')
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              class: "wf-logo wf-logo-small",
              src: require('@/assets/well-small.svg')
            }, null, 8, ["src"]))
      ]),
      (!_ctx.isMobile)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headerLinks, (link) => {
              return (_openBlock(), _createBlock("a", {
                class: "wf-header-link",
                key: link.id,
                href: link.id,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveToUrl && _ctx.moveToUrl(...args)))
              }, _toDisplayString(link.label), 9, ["href"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    end: _withId(() => [
      (!_ctx.isMobile)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("a", {
              class: "mr-1 wf-nodecoration",
              href: `tel:${_ctx.publicPhone}`
            }, [
              _createVNode(_component_Button, {
                icon: "pi pi-phone",
                label: _ctx.prettifyPhone(_ctx.publicPhone),
                class: "p-button-warning"
              }, null, 8, ["label"])
            ], 8, ["href"]),
            _createVNode(_component_Button, {
              label: _ctx.isMobile ? 'Заявка' : 'Оставить заявку',
              icon: "pi pi-envelope",
              class: "",
              onClick: _ctx.proceedToOrder
            }, null, 8, ["label", "onClick"])
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_SplitButton, {
              icon: "pi pi-envelope",
              model: _ctx.contactItems,
              class: "mr-1",
              onClick: _ctx.proceedToOrder
            }, null, 8, ["model", "onClick"]),
            _createVNode("a", {
              class: "mr-1 wf-nodecoration",
              href: `tel:${_ctx.publicPhone}`
            }, [
              _createVNode(_component_Button, {
                icon: "pi pi-phone",
                class: "p-button-warning"
              })
            ], 8, ["href"])
          ], 64))
    ]),
    _: 1
  }, 8, ["class"])), [
    [_vShow, _ctx.isHidden]
  ])
})